import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=2cd2db2e&scoped=true&"
import script from "./AreaSelect.vue?vue&type=script&lang=ts&"
export * from "./AreaSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=2cd2db2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2db2e",
  null
  
)

export default component.exports